export default __webpack_public_path__ + "static/media/certificateImg.27062ee6.svg";